import TariffComponents from "../../../utils/services/project/accounting/tariffPlanComponentService";
import crudTemplate from "../../../templates/crudTemplate";
import i18n from "../../../../plugins/i18n";
let crud = crudTemplate(TariffComponents);
function prepareItem(item) {
  item.conversion_text =
    item.conversion === null
      ? i18n.t("tariff-plans.None")
      : item.conversion_text;

  item.conversion_text =
    item.conversion === "max-extrapolate-kwh/¼h-kw"
      ? i18n.t("tariff-plans.maxExtrapolateKwh15min")
      : item.conversion_text;
  item.conversion_text =
    item.conversion === "max-extrapolate-kwh/½h-kw"
      ? i18n.t("tariff-plans.maxExtrapolateKwh30min")
      : item.conversion_text;

  item.type = item.type ? item.type : null;
  item.type_text =
    item.type === "rateMaxPeriod"
      ? i18n.t("tariff-plans.rateMaxPeriod")
      : item.type_text;
  item.type_text =
    item.type === "rateSumPeriod"
      ? i18n.t("tariff-plans.rateSumPeriod")
      : item.type_text;
  item.type_text =
    item.type === "rateMaxDaily"
      ? i18n.t("tariff-plans.rateMaxDaily")
      : item.type_text;
  item.type_text =
    item.type === "rateMaxMonthly"
      ? i18n.t("tariff-plans.rateMaxMonthly")
      : item.type_text;
  item.type_text =
    item.type === "feeDaily" ? i18n.t("tariff-plans.DailyFee") : item.type_text;
  item.type_text =
    item.type === "feeMonthly"
      ? i18n.t("tariff-plans.MonthlyFee")
      : item.type_text;
  return item;
}

const state = {
  ...crud.state
};

const getters = {
  ...crud.getters,
  getList(state) {
    let list = crud.getters.getList(state);
    return list.map(prepareItem);
  },
  getItem() {
    let item = crud.getters.getItem(state);
    item.project_id = item._project && item._project.id;
    return item.map(prepareItem);
  }
};

const actions = {
  ...crud.actions,
  create(_, { item, errorHandler = () => {}, onSuccess = () => {} }) {
    item = {
      _tariff_plan: { id: item.tariff_plan_id },
      project_id: item.project_id,
      name: item.name,
      conversion: item.conversion_text?.value ?? null,
      unit_symbol: item.unit_symbol,
      type: item.type_text.value ? item.type_text.value : item.type
    };
    return crud.actions.create(_, {
      item: { ...item },
      errorHandler,
      onSuccess
    });
  },
  update(_, { item, errorHandler = () => {}, onSuccess = () => {} }) {
    item = {
      id: item.id,
      _tariff_plan: { id: item.tariff_plan_id },
      project_id: item.project_id,
      name: item.name,
      conversion: item.conversion_text?.value ?? null,
      unit_symbol: item.unit_symbol,
      type: item.type_text.value ? item.type_text.value : item.type
    };
    return crud.actions.update(_, {
      item: { ...item },
      errorHandler,
      onSuccess
    });
  }
};

const mutations = {
  ...crud.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
